import ACTION_ITEMS from "../actionItems";

export function setSelectedProject(project) {
  return {
    type: ACTION_ITEMS.PROJECT_BUILDER.SELECTED_PROJECT.SET,
    payload: project,
  };
}
